import { CompoundFilterOptionProps } from './CompoundFilterOption.types';
import { useStyles } from './CompoundFilterOption.styles';
import { Button } from '../../../../../buttons/Button';
import { CircleX } from '../../../../../icons';
import { RenderWhen } from '../../../../../RenderWhen';

export const CompoundFilterOption = ({
  isActive,
  isRemovable,
  label,
  onClick,
  onRemove,
}: CompoundFilterOptionProps) => {
  const styles = useStyles({ isActive });

  return (
    <Button
      css={styles.button}
      onClick={onClick}
      isActive={isActive}
      size="sm"
      className="capitalize"
    >
      {label}

      <RenderWhen condition={isRemovable}>
        <CircleX
          role="img"
          aria-label="Remove Option"
          css={styles.icon}
          size="1rem"
          className="cursor-pointer"
          onClick={(e) => {
            /**
             * Since icon is inside a button, not stopping the propagation of the click
             * will trigger onClick for button above
             */
            e.stopPropagation();
            onRemove();
          }}
        >
          <title>Remove Option</title>
        </CircleX>
      </RenderWhen>
    </Button>
  );
};
